import { Component, ViewEncapsulation } from '@angular/core';
import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-multiple-search-select-plus-input',
    templateUrl: './multiple-search-select-plus-input.component.html',
    styleUrls: ['./multiple-search-select-plus-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MultipleSearchSelectPlusInputComponent extends BaseFormInput {
  getSelectedDisplay(selected: any[], options: any[]): string {
    if (!selected || selected.length === 0) return '';
    const selectedOptions = options.filter(opt => selected.includes(opt.value));
    if (selectedOptions.length === 1) return selectedOptions[0].label;
    return `${selectedOptions[0].label} \u2795${selectedOptions.length - 1}`;
  }
}
